import { Howler } from 'howler';

class AudioServiceHowler {
  constructor() {
    document.addEventListener(
      'visibilitychange',
      this.onVisibilityChange,
      false
    );
  }

  mute = () => {
    Howler.mute(true);
  };

  unmute = () => {
    Howler.mute(false);
  };

  volume = (val) => {
    Howler.volume(val);
  };

  stopAll = () => {
    Howler.stop();
  };

  onVisibilityChange = () => {
    if (document.hidden) {
      this.mute();
    } else {
      this.unmute();
    }
  };
}

const service = new AudioServiceHowler();
window.AudioServiceHowler = service;
export default service;
